'use strict';

function queryCookie(key) {
  let value;
  const info = document.cookie.split('; ');
  info.forEach(index => {
    const arr = index.split('=');
    if (arr[0] === key) {
      value = arr[1];
    }
  });
  return value;
}

function reportBI(evid, report) {
  const base = 'https://frog.wix.com/';

  report = report || [];
  report.push(`evid=${evid}`);
  report.push('src=19');

  report.push(`origin=${window.location.host}${window.location.pathname}`);
  report.push(`_=${new Date().getTime()}`);

  const img = new Image();
  img.src = `${base}hf?${report.join('&')}`;
}

export {queryCookie, reportBI};
